<template>
    <div class="overflow-hidden">
        <div class="wow fadeInUp" data-wow-delay=".15s" style="visibility: visible; animation-delay: 0.15s">
            <div v-if="image_url" class="mb-6 flex justify-center min-h-[300px] w-full max-h-[300px] border rounded-xl">
                <img :src="image_url" :alt="title || ''" :class="image_40 ? 'object-contain' : ''" class="" />
            </div>
            <p class="my-5 box-title font-medium text-left" v-if="title">
                {{ title }}
            </p>
            <p class="box-description text-left" v-if="body">
                {{ body }}
            </p>
        </div>
    </div>
</template>

<script lang="ts">
export default {
    props: {
        image_url: String,
        image_40: Boolean,
        rectangular: Boolean,
        icon: String,
        title: String,
        body: String,
        total: String,
    },
};
</script>
